// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconBankPath = 'M16.846 9.609a1.003 1.003 0 0 1-.793.39H4.079a1.01 1.01 0 0 1-.793-.39l-.25-.324 6.968-4.125 7.086 4.132-.244.317ZM14 17.999v-6h2v5c0 .352.06.689.17 1H14Zm-6 0h4v-6H8v6Zm-2 0H3.829a2.98 2.98 0 0 0 .17-1v-5.01c.028.002.054.01.08.01h1.92v6Zm12-1v-5.727c.157-.134.305-.28.432-.444L20 8.708l-9-5.282V2.099c.68.107 1.622.33 2.553.796l.895-1.789C12.26.013 10.09 0 10 0H9v3.43L.074 8.715l1.628 2.116c.088.113.196.206.298.305V17a1 1 0 0 1-1 1H0v2h20v-2h-1c-.551 0-1-.448-1-1Z';
var IconBank = baseIcon('IconBank', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconBankPath
});
export default IconBank;
//# sourceMappingURL=index.js.map